import React, { useEffect, useState } from 'react'
import { Alert as MuiAlert, Box, LinearProgress } from '@mui/material'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'

import useAlert from '../hooks/useAlert'

function Alert({ disableTimeout }) {
  const { text, type, timeout, unsetAlert } = useAlert()
  const INTERVAL = 250
  const [progress, setProgress] = useState(100)

  useEffect(() => {
    if (progress === 0) {
      unsetAlert()
    }
  }, [progress, unsetAlert])

  useEffect(() => {
    let timer
    if (!disableTimeout) {
      if (isEmpty(text)) {
        setProgress(100)
        clearInterval(timer)
      } else {
        timer = setInterval(() => {
          setProgress((prevProgress) => {
            if (prevProgress === 0) {
              return 100
            }
            const timeToPercent = (INTERVAL * 100) / timeout
            return prevProgress - timeToPercent
          })
        }, INTERVAL)
      }
    }
    return () => {
      if (!disableTimeout) {
        clearInterval(timer)
      }
    }
  }, [disableTimeout, text, timeout])

  const handleClose = () => {
    unsetAlert()
  }

  if (isEmpty(text)) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        zIndex: 9999,
      }}
    >
      {!disableTimeout && (
        <LinearProgress variant="determinate" value={progress} />
      )}
      <MuiAlert
        severity={type}
        onClose={handleClose}
        sx={(theme) => ({ padding: theme.spacing(2), opacity: 0.95 })}
      >
        {text}
      </MuiAlert>
    </Box>
  )
}
Alert.propTypes = {
  disableTimeout: PropTypes.bool,
}
Alert.defaultProps = {
  disableTimeout: false,
}
export default Alert
